export default {
  namespaced: true,
  state: {
    spinControlPanelStatus: false,
    selectedButtons: [true],
    selectedPosition: 'onspin',
    selectedIconsStyle: 'flat',
    background: 'rgba(244,244, 244,1)',
    color: 'rgba(51,51,51,1)',
    size: 30,
    spinControlModalStatus: false,
    spinControlModalApprove: false
  },
  mutations: {
    changeSpinControlPanelSettings(state, payload) {
      state.spinControlPanelStatus = payload.status
      state.selectedButtons = payload.selectedButtons
      state.selectedPosition = payload.selectedPosition
      state.selectedIconsStyle = payload.selectedIconsStyle
      state.background = payload.background
      state.color = payload.color
      state.size = payload.size
    },
    changeSpinControlModalStatus(state, payload) {
      state.spinControlModalStatus = payload
    },
    changeSpinControlModalApprove(state, payload) {
      state.spinControlModalApprove = payload
    }
  },
  actions: {
    changeSpinControlPanelSettings({ commit }, value) {
      commit('changeSpinControlPanelSettings', value)
    },
    changeSpinControlModalStatus({ commit }, value) {
      commit('changeSpinControlModalStatus', value)
    },
    changeSpinControlModalApprove({ commit }, value) {
      commit('changeSpinControlModalApprove', value)
    }
  },
  getters: {
    spinControlPanelStatus: state => state.spinControlPanelStatus,
    spinSelectedButtons: state => state.selectedButtons,
    spinControlSelectedPosition: state => state.selectedPosition,
    spinControlSelectedIconsStyle: state => state.selectedIconsStyle,
    spinControlBackground: state => state.background,
    spinControlIconsColor: state => state.color,
    size: state => state.size,
    spinControlModalStatus: state => state.spinControlModalStatus,
    spinControlModalApprove: state => state.spinControlModalApprove
  }
}
